<app-pay-g *ngIf="english"></app-pay-g>
<app-pay-g-hindi *ngIf="hindi"></app-pay-g-hindi>